import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { HOME } from '../../views/home/routes';

interface PublicRouteProps {
  element: React.ReactElement;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ element }) => {
  const { token } = useAuth();

  return token ? <Navigate to={HOME()} /> : element;
};

export default PublicRoute;
